import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

import { BorderThemeProps } from 'shared/types/Theme';

import { BorderPanel } from '@/components/Theme/BorderPanel';
import { ResetButton } from '@/components/Theme/ResetButton';
import { SwitchPanel } from '@/components/Theme/SwitchPanel';
import { useCurrentDocument } from '@/components/YjsProvider';
import { useActivityThemeStylesProperty } from '@/contentObjects/Root/hooks/useActivityThemeStylesProperty';
import { TooltipConfigProps } from '@/utils/tiptap/extensions/Tooltip/components/TooltipConfig';
import { FormControl } from '@/widgets/_components/FormControl';

export function Borders(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, resolvedStyles, onUpdateStyle } = props;
  const { t } = useTranslation('components', { keyPrefix: 'theme.settings' });

  const setBorder = useCallback(
    (newBorder: BorderThemeProps) => {
      onUpdateStyle({ border: newBorder });
    },
    [onUpdateStyle]
  );

  const setIsBorderVisible = useCallback(
    (newIsBorderVisible: boolean) => {
      onUpdateStyle({ isBorderVisible: newIsBorderVisible });
    },
    [onUpdateStyle]
  );

  const document = useCurrentDocument();
  const [borderColorFallback] = useActivityThemeStylesProperty<string>(
    document,
    'global.content.colors.decoration.main'
  );

  return (
    <FormControl title={t('borders')}>
      <SwitchPanel
        value={resolvedStyles.isBorderVisible}
        onChange={setIsBorderVisible}
        ResetButton={'isBorderVisible' in styles && <ResetButton onClick={() => onRemoveStyle('isBorderVisible')} />}
      />
      <BorderPanel
        label={t('borderStyle')}
        border={{ ...resolvedStyles.border, borderColor: resolvedStyles.border.borderColor ?? borderColorFallback }}
        setBorder={setBorder}
        ResetButton={styles.border && <ResetButton onClick={() => onRemoveStyle('border')} />}
      />
    </FormControl>
  );
}
